import { Component, OnInit } from '@angular/core';
import {
  ServicioImprimirAdmisionService,
  ParametrosImprimirAdmisionEntity,
  EntidadEmpresarial,
  InformacionUsuarioEntity
} from 'src/app/services/servicio-imprimir-admision.service';
import { ActivatedRoute } from '@angular/router';
import { RecordatorioCitasEntity, ServicioRecordatorioCitasService } from 'src/app/services/servicio-recordatorio-citas.service';
import { ServicioParametroSimensService } from 'src/app/services/servicio-parametro-simens.service';

@Component({
  selector: 'app-reporte-recordatorio-citas',
  templateUrl: './reporte-recordatorio-citas.component.html',
  styleUrls: ['./reporte-recordatorio-citas.component.css']
})
export class ReporteRecordatorioCitasComponent implements OnInit {

  private parametrosUrl: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: ''
  };

  public errorDataReporte = false;
  public loading = true;
  public error = false;
  public fechaImpresion: Date = new Date();
  public uncoCirugia: string;
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };
  public dataUsuario: InformacionUsuarioEntity = {
    nombreUsuario: '',
    codigoBarrasImprime: ''
  };
  // public dataReporte: RecordatorioCitasEntity[] = [];
  public dataReporte: RecordatorioCitasEntity = {
    sede: '',
    puntoAtencion: '',
    profesionalSalud: '',
    identificacionAfiliado: '',
    afiliado: '',
    telefonoAfiliado: '',
    periodoInical: '',
    duracion: '',
    fechaCita: '',
    mes: '',
    dia: '',
    autorizacionConsultaExterna: '',
    empresa: '',
    procedimiento: '',
    codigoProcedimiento: '',
    tipoDocumento: '',
    direccionSede: '',
    telefonoMovil: '',
    telefonoPbx: '',
    tipoHora: '',
    detalleCita: ''
  };

  informacionAdicional: string;

  constructor(
    private servicioAdmision: ServicioImprimirAdmisionService,
    private servicioRecordatorio: ServicioRecordatorioCitasService,
    private servicioParametroSimens: ServicioParametroSimensService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.parametrosUrl.codigoBaseDatos = params.codigoBaseDatos;
      this.parametrosUrl.uncoSede = params.uncoSede;
      this.parametrosUrl.uncoLogin = params.uncoLogin;
      this.uncoCirugia = params.uncoCirugia;
    });
  }

  ngOnInit() {
    this.generate();
  }

  public generate() {
    this.getInfoEntidadEmpresarial();
  }

  public getPrint() {
    window.print();
  }

  /* Consumo de servicios */
  private async getInfoEntidadEmpresarial() {
    this.loading = true;
    const response = await this.servicioAdmision.getEntidadEmpresarial(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataEntidadEmpresarial = data[0];
        this.getInfoUsuario();
      } else {
        this.errorDataReporte = true;
        this.loading = false;
      }
    }, (error: any) => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoUsuario() {
    const response = await this.servicioAdmision.getInformacionUsuario(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataUsuario = data[0];
        this.getParametroSimens();
      } else {
        this.errorDataReporte = true;
        this.loading = false;
      }
      // console.log(this.dataUsuario);
    }, (error: any) => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getParametroSimens() {
    const response = await this.servicioParametroSimens.getParametroSimensBySede(this.parametrosUrl.codigoBaseDatos, Number(this.parametrosUrl.uncoSede));
    response.subscribe((data: any) => {
      this.informacionAdicional = data && data.infoAdicionalRecordatorioCitas ? data.infoAdicionalRecordatorioCitas : '';
      this.getDataRecordatorioCitas();
    }, (error: any) => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getDataRecordatorioCitas() {
    const response = await this.servicioRecordatorio.getDataRecordatorioCitas(this.parametrosUrl.codigoBaseDatos, this.uncoCirugia);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataReporte = data[0];
        this.loading = false;
      }
    }, (error) => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });

  }

}
